'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _DropzoneS3Uploader = require('./DropzoneS3Uploader');

var _DropzoneS3Uploader2 = _interopRequireDefault(_DropzoneS3Uploader);

exports['default'] = _DropzoneS3Uploader2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-dropzone-s3-uploader/lib/index.js
// module id = 1030
// module chunks = 0